import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SubgroupIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5 1C4.44772 1 4 1.44772 4 2V3C4 3.55228 4.44772 4 5 4H11C11.5523 4 12 3.55228 12 3V2C12 1.44772 11.5523 1 11 1H5Z"
		></path>
		<path
			fill="currentColor"
			d="M2 12C1.44772 12 1 12.4477 1 13V14C1 14.5523 1.44772 15 2 15H6C6.55228 15 7 14.5523 7 14V13C7 12.4477 6.55228 12 6 12H2Z"
		></path>
		<path
			fill="currentColor"
			d="M3.25 11H4.75V9.5C4.75 9.08579 5.08579 8.75 5.5 8.75H6.5C7.07627 8.75 7.60193 8.53336 8 8.17708C8.39807 8.53336 8.92373 8.75 9.5 8.75H10.5C10.9142 8.75 11.25 9.08579 11.25 9.5V11H12.75V9.5C12.75 8.25736 11.7426 7.25 10.5 7.25H9.5C9.08579 7.25 8.75 6.91421 8.75 6.5V5H7.25V6.5C7.25 6.91421 6.91421 7.25 6.5 7.25H5.5C4.25736 7.25 3.25 8.25736 3.25 9.5V11Z"
		></path>
		<path
			fill="currentColor"
			d="M14 12H10C9.44772 12 9 12.4477 9 13V14C9 14.5523 9.44772 15 10 15H14C14.5523 15 15 14.5523 15 14V13C15 12.4477 14.5523 12 14 12Z"
		></path>
	</svg>
))
